import React from 'react';
import Select from 'react-select';


/**
 * Breed Select Switcher component
 */
const DiagnosesSwitcher = (props) => {
  let options = [];
  props.data.data.map((value, index) => {
    let disabled = false;
    if(props.selected.includes(index)){
      disabled = true;
    }
    options.push({value: index, label:value.label, isDisabled: disabled});
  });

  return(
    <div id="nppe2-fc-validate-diagnoses" className="nppe2-fc-diagnoses-switcher">
      <Select
        options={options}
        className="nppe2-fc-react-select"
        name="nppe2-fc-diagnoses-switcher-select"
        onChange={(selectedOption) => props.onSelect(selectedOption.value)}
        placeholder={props.data.dropdownLabel}
        value={false}
        aria-label={props.data.dropdownLabel}
        noOptionsMessage={() => props.data.noOptionsMsg}
      />
    </div>
  )
};


export default DiagnosesSwitcher;
